import React, {useEffect, useState, useRef} from 'react'
import {Row, Col, Tabs, Card, Button, Tooltip} from 'antd'

import { connect } from 'react-redux'

import CurrencyTransactions from './CurrencyTransactions'
import Rub from './Rub'

import './index.scss'
import {TabsInfoIco} from "../../../../../modules/CustomIcons";
import {useHistory, useLocation} from "react-router-dom";
import CustomTooltip from "components/Tooltip";
import {getPathnameByIndex} from "../../../../services/helper";
import {checkPermission} from "../../../../services/permission";
import {getCurrentCompany} from "../../../../services/user";
import { useTranslation } from 'react-i18next'
import noSelected from "assets/images/noSelectedTransfer.svg";
import {getMessageLists} from "store/actions/home";
import { useConveyer } from "@egjs/react-conveyer";


const TransferDomestic: React.FC<any> = ({companyData,messageList}) => {
    const {t} = useTranslation();
    const ref = useRef<HTMLDivElement>(null);
    useConveyer(ref, {
      horizontal: true,
    });

    const language = localStorage.getItem("i18nextLng")
    const [textArray_Currency,setTextArray_Currency] = useState([])
    const [textArray_Rub,setTextArray_Rub] = useState([])

    const fetchessageData = async () => {

        let lang_text_currency = messageList?.result !== undefined ? (language=="az" ? messageList.result.find(text=> text.messageKey === 'INFO.TR_SWIFT')?.textAZE :
            language=="ru" ?  messageList.result.find(text=> text.messageKey === 'INFO.TR_SWIFT')?.textRU : language=="en" ?  messageList.result.find(text=> text.messageKey === 'INFO.TR_SWIFT')?.textENG :"") : "";
        const array_currency = lang_text_currency !== null  && lang_text_currency !== undefined ? lang_text_currency.split("|") :[];

        let lang_text_rub = messageList?.result !== undefined ? (language=="az" ? messageList.result.find(text=> text.messageKey === 'INFO.TR_RUB')?.textAZE :
            language=="ru" ?  messageList.result.find(text=> text.messageKey === 'INFO.TR_RUB')?.textRU : language=="en" ?  messageList.result.find(text=> text.messageKey === 'INFO.TR_RUB')?.textENG :"") : "";
        const array_rub = lang_text_rub !== null && lang_text_rub !== undefined ? lang_text_rub.split("|") : [];


        setTextArray_Currency(array_currency)
        setTextArray_Rub(array_rub)
    };
    useEffect(() => {
        fetchessageData()
    }, [messageList,language])

    const TooltipMessageCurrency = `
    ${
        textArray_Currency.map((line:any,index:number) => {

            return(

                line.startsWith('http') ?
                    `<a href=${line} key=${index} > ${line} </a>`
                    :
                    `<p key=${index}> ${line} </p>`
            )
        }).join('')
    }
    `

    const TooltipMessageRub = `
    ${
        textArray_Rub.map((line:any,index:number) => {

            return(

                line.startsWith('http') ?
                    `<a href=${line} key=${index} > ${line} </a>`
                    :
                    `<p key=${index}> ${line} </p>`
            )
        }).join('')
    }
    `

    const tabInnerData: Array<any> = [
    {
      index: 1,
      title: t("home.foreignCurrencyTransfer"),
      description : TooltipMessageCurrency,
      content: <CurrencyTransactions/>,
        path : '/new_transfer/foreign_currency/money_transfer',
        permissionKey : 'SWIFT',
    },
    {
      index: 2,
      title: 'RUB',
      description : TooltipMessageRub,
      content: <Rub/>,
        path : '/new_transfer/foreign_currency/rub',
        permissionKey : 'SWIFT_RUB',
    }
  ]
  const { TabPane } = Tabs;
    const history = useHistory();
    const location = useLocation();
    const find_tab=tabInnerData.find(row => row.path.includes(getPathnameByIndex(2)));
    const [tabActiveKey, setTabActiveKey] = useState<number>(find_tab?.index);

    useEffect(() => {
        const find_tab=tabInnerData.find(row => row.path.includes(getPathnameByIndex(2)));

        setTabActiveKey(find_tab?.index);

    }, [location, companyData])

    const tabOnChange = (activeKey) => {
        setTabActiveKey(old_key => activeKey);

        const find_row=tabInnerData.find(row => row.index==activeKey);

        if (find_row){
            history.push(find_row.path);
        }
    };

  return (
    <Row className='transfer_child_tabs' ref={ref}>
      <Col span={24} style={{minWidth: "800px"}}>
          <Tabs
              activeKey={`${tabActiveKey}`}
              onChange={tabOnChange}
              id="transferTab"
              destroyInactiveTabPane={true}
          >

            {tabInnerData &&
              tabInnerData.map((item) => {
                return checkPermission(item.permissionKey) && (
                  <TabPane tab={<span>{item.title}

                      <CustomTooltip
                          title={item.description}
                      >
                          <Button type={'ghost'} className={'transparent'} icon={<TabsInfoIco />} />
                      </CustomTooltip>


                  </span>} key={item.index}>
                    {item.content}
                  </TabPane>
                )
              })}
          </Tabs>
      </Col>
        { tabActiveKey === undefined && <span className={'noSelected'}>{t("newTransfer.noSelectedTransfer")}
            <img src={noSelected}/>
              </span> }
    </Row>
  )
}

const mapStateToProps = (state: any) => ({
    companyData: (state.user &&  state.user.companyData.result) ?  state.user.companyData.result.customerNo  : getCurrentCompany(),
    messageList: state.home.messageList,

})
const mapDispatchToProps = { getMessageLists }
export default connect(mapStateToProps, mapDispatchToProps)(TransferDomestic)
